<template>
    <div class="articledetailpage" :class="{'bodyfont-unauth': !user}">
        <spinner class="pink" v-model="toggleSpinner" v-if="toggleSpinner" size="lg" fixed text="fetching article"></spinner>
        <div class="container" v-if="articleObject">
            <div class="row">
                <div class="col-sm-8">
                    <h3 class="titleofarticle">{{articleObject.articleHead}}</h3>
                    <h6 v-if="!articleObject.authorUrl">{{articleObject.authorName}} - {{articleObject.datePublishFmt}}</h6>
                    <h6 v-if="articleObject.authorUrl"><a target="_blank" :href="articleObject.authorUrl">{{articleObject.authorName}}</a> - {{articleObject.datePublishFmt}}</h6>
                </div>
                <div class="col-sm-4">

                </div>
            </div>
            <div class="clearfix"></div>
            <div class="imageholderbanner">
                <img :src="articleObject.imageUrl" :title="articleObject.articleHead" :alt="articleObject.articleHead" />
            </div>
            <social-sharing network-tag="button" v-bind:url="videoURL" v-bind:quote = "articleObject.articleHead" v-bind:description = "articleObject.articleHead" v-bind:title = "'TONE Networks, Set the Tone of Your Life'"  inline-template>
                <div class="shareIcons">
                    <network network="facebook" class="holder"><span class="sr-only">Share via facebook</span>
                        <i aria-hidden="true" class="fa fa-2x fa-facebook cursor"></i>
                    </network>
                    <network network="twitter" class="holder"><span class="sr-only">Share via twitter</span>
                        <i aria-hidden="true" class="fa fa-2x fa-twitter cursor"></i>
                    </network>
                    <network network="linkedin" class="holder"><span class="sr-only">Share via linkedin</span>
                        <i aria-hidden="true" class="fa fa-2x fa-linkedin cursor"></i>
                    </network>
                    <network network="email" class="holder"><span class="sr-only">Share via email</span>
                        <i aria-hidden="true" class="fa fa-2x fa-envelope cursor"></i>
                    </network>
                </div>
            </social-sharing>
            <div class="row">
                <div class="col-sm-8" v-if="articleList && articleList.length > 0">
                    <p v-if="articleObject.paragraph1" v-html="articleObject.paragraph1">
                    </p>
                    <p v-if="articleObject.paragraph2" v-html="articleObject.paragraph2">
                    </p>
                    <p v-if="articleObject.paragraph3" v-html="articleObject.paragraph3">
                    </p>
                    <p v-if="articleObject.paragraph4" v-html="articleObject.paragraph4">
                    </p>
                    <p v-if="articleObject.paragraph5" v-html="articleObject.paragraph5">
                    </p>
                    <p v-if="articleObject.paragraph6" v-html="articleObject.paragraph6">
                    </p>
                    <p v-if="articleObject.paragraph7" v-html="articleObject.paragraph7">
                    </p>
                    <p v-if="articleObject.paragraph8" v-html="articleObject.paragraph8">
                    </p>
                    <p v-if="articleObject.paragraph9" v-html="articleObject.paragraph9">
                    </p>
                    <p v-if="articleObject.paragraph10" v-html="articleObject.paragraph10">
                    </p>
                    <social-sharing network-tag="button" v-bind:url="videoURL" v-bind:quote = "articleObject.articleHead" v-bind:description = "articleObject.articleHead" v-bind:title = "'TONE Networks, Set the Tone of Your Life'"  inline-template>
                        <div class="shareIcons bottom">
                            <network network="facebook" class="holder"><span class="sr-only">Share via facebook</span>
                                <i aria-hidden="true" class="fa fa-2x fa-facebook cursor"></i>
                            </network>
                            <network network="twitter" class="holder"><span class="sr-only">Share via twitter</span>
                                <i aria-hidden="true" class="fa fa-2x fa-twitter cursor"></i>
                            </network>
                            <network network="linkedin" class="holder"><span class="sr-only">Share via linkedin</span>
                                <i aria-hidden="true" class="fa fa-2x fa-linkedin cursor"></i>
                            </network>
                            <network network="email" class="holder"><span class="sr-only">Share via email</span>
                                <i aria-hidden="true" class="fa fa-2x fa-envelope cursor"></i>
                            </network>
                        </div>
                    </social-sharing>
                </div>
                <div class="col-sm-12" v-else>
                    <p v-if="articleObject.paragraph1" v-html="articleObject.paragraph1">
                    </p>
                    <p v-if="articleObject.paragraph2" v-html="articleObject.paragraph2">
                    </p>
                    <p v-if="articleObject.paragraph3" v-html="articleObject.paragraph3">
                    </p>
                    <p v-if="articleObject.paragraph4" v-html="articleObject.paragraph4">
                    </p>
                    <p v-if="articleObject.paragraph5" v-html="articleObject.paragraph5">
                    </p>
                    <p v-if="articleObject.paragraph6" v-html="articleObject.paragraph6">
                    </p>
                    <p v-if="articleObject.paragraph7" v-html="articleObject.paragraph7">
                    </p>
                    <p v-if="articleObject.paragraph8" v-html="articleObject.paragraph8">
                    </p>
                    <p v-if="articleObject.paragraph9" v-html="articleObject.paragraph9">
                    </p>
                    <p v-if="articleObject.paragraph10" v-html="articleObject.paragraph10">
                    </p>
                    <social-sharing network-tag="button" v-bind:url="videoURL" v-bind:quote = "articleObject.articleHead" v-bind:description = "articleObject.articleHead" v-bind:title = "'TONE Networks, Set the Tone of Your Life'"  inline-template>
                        <div class="shareIcons bottom">
                            <network network="facebook" class="holder"><span class="sr-only">Share via facebook</span>
                                <i aria-hidden="true" class="fa fa-2x fa-facebook cursor"></i>
                            </network>
                            <network network="twitter" class="holder"><span class="sr-only">Share via twitter</span>
                                <i aria-hidden="true" class="fa fa-2x fa-twitter cursor"></i>
                            </network>
                            <network network="linkedin" class="holder"><span class="sr-only">Share via linkedin</span>
                                <i aria-hidden="true" class="fa fa-2x fa-linkedin cursor"></i>
                            </network>
                            <network network="email" class="holder"><span class="sr-only">Share via email</span>
                                <i aria-hidden="true" class="fa fa-2x fa-envelope cursor"></i>
                            </network>
                        </div>
                    </social-sharing>
                </div>
                <div class="col-sm-4" v-if="articleList && articleList.length > 0">
                <div class="pinklinksholder">
                    <h4>More Articles</h4>
                    <div v-for="article in articleList">
                        <div class="listholderlinks">
                        <a v-a11y-action href="javascript:" @click="redirectToNextArticle(article)" :title="article.articleHead">{{article.articleHead}}</a><small v-a11y-action  @click="redirectToNextArticle(article)" >{{article.authorName}} - {{article.datePublishFmt}}</small>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import spinner from '@/accessibility/Spinner'
    import alert from '@/accessibility/Alert'
    import input from '@/accessibility/Input'
    import { mapGetters } from 'vuex'
//    import slick from 'slick-carousel'
//    import $ from 'jquery'

    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert
        },
        name: 'setthetone',
        metaInfo () {
            let self = this
            return {
                title: self.sTitle,
                meta: [
                    {property: 'og:image', content: self.sImage},
                    {property: 'og:title', content: self.sTitle},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: self.sDesc
                    },
                    {property: 'twitter:title', content: self.sTitle},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.sImage},
                    {
                        property: 'twitter:description',
                        content: self.sDesc
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                success: false,
                successMsg: '',
                contactForm: {
                    emailAddress: '',
                    phoneNumber: '',
                    reason: '',
                    comments: ''
                },
                videoURL: window.location.href,
                articleList: null,
                articleObject: null,
                articleId: 0,
                spinner: false,
                sharingTitle: 'TONE Networks, Set the Tone of Your Life',
                sharingDescription: 'Give the gift of knowledge and inspiration to the women you care about',
                toggleSpinner: false,
                sTitle: '',
                sImage: '',
                sDesc: ''
            }
        },
        computed: {
            ...mapGetters([
                'error', 'user', 'getAllArticles', 'getSelectedArticle'
            ])
        },
        methods: {
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            redirectToNextArticle (article) {
                this.$router.push(`/setthetone/article/${article.toneArticleId}/${article.articleHead.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
            }
        },
        watch: {
            '$route.params.articleId' (to, from) {
                let self = this
                // Start Updating Article
                self.articleId = self.$route.params.articleId
                if (self.articleId > 0) {
                    self.toggleSpinner = true
                    self.videoURL = window.location.href
                    // 0.Enable spinner
                    // 1. Refreshing Page All Articles
                    self.$store.dispatch('GETALLARTICLES').then(() => {
                        if (self.getAllArticles) {
                            self.articleList = null
                            self.articleList = self.getAllArticles.filter(x => {
                                return x.toneArticleId.toString() !== self.articleId.toString()
                            })
                        }
                    })
                    // 2. Refreshing Main arcile
                    self.$store.dispatch('GETSELECTEDARTICLE', self.articleId).then(() => {
                        if (self.getSelectedArticle) {
                            self.articleObject = self.getSelectedArticle
                            self.sTitle = `TONE Article | ${self.articleObject.articleHead}`
                            self.sImage = self.articleObject.imageUrl
                            self.sDesc = self.articleObject.paragraph1
                            self.$store.dispatch('CACHEPAGE', window.location.href)
                            self.toggleSpinner = false
                        }
                    })
                }
            }
        },
        mounted: function () {
            let self = this
            if (self.$route.params.articleId && self.$route.params.articleId > 0) {
                self.articleId = self.$route.params.articleId
                self.$store.dispatch('GETALLARTICLES').then(() => {
                    if (self.getAllArticles) {
                        self.articleList = self.getAllArticles.filter(x => {
                            return x.toneArticleId.toString() !== self.articleId.toString()
                        })
                    }
                })
                self.$store.dispatch('GETSELECTEDARTICLE', self.articleId).then(() => {
                    if (self.getSelectedArticle) {
                        self.articleObject = self.getSelectedArticle
                        self.sTitle = `TONE Article | ${self.articleObject.articleHead}`
                        self.sDesc = self.articleObject.paragraph1
                        self.sImage = self.articleObject.imageUrl
                        console.log('article', self.getSelectedArticle)
                    }
                })
                self.$store.dispatch('CACHEPAGE', window.location.href)
            } else {
                self.$router.push('/')
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .articledetailpage {
        /* color: #f0617d; */
        text-align: left;
        /* margin: 30px 0 30px; */
        /* border-bottom: 2px solid #f0617d; */
        font-size: 16px;
    }

    .articledetailpage h3 {
        color: #f0617d;
        text-align: left;
        margin: 40px 0 10px;
        border-bottom: 2px solid #f0617d;
        padding: 20px 0 10px;
        font-weight: 700;
    }

    .articledetailpage h6 {
        font-size: 18px;
        font-weight: 600;
        margin: 0 0 20px;
    }

    .imageholderbanner img {
        width: 100%;
        height: auto;
        margin: 0 0 30px;
    }

    .pinklinksholder {
        border: 2px solid #f0617d;
        border-radius: 5px;
        padding: 20px;
    }

    .pinklinksholder h4 {
        color: #f0616d;
        text-align: center;
        font-size: 22px;
        font-weight: 900;
        margin: 0 0 20px;
    }

    .pinklinksholder a {
        display: block;
        padding: 10px 0;
        font-weight: 600;
        text-decoration: underline;
    }
    .pinklinksholder small {
        display:block;
        text-decoration:none !important;
        color:#333;
    }
    .pinklinksholder a + small {
        cursor: pointer;
        margin-top: -10px;
    }


</style>
<style>
    .articledetailpage > .container{
        position:relative;
    }

    .articledetailpage > .container > .shareIcons:before {
        content:"SHARE";
        font-family:'open sans';
        font-weight:700;
        display:block;
        margin:0 0 20px
    }
    .articledetailpage > .container > .shareIcons {
        width: 75px;
        position: absolute;
        left: 0px;
        padding: 15px;
        text-align: center;
        top: 130px;
        background:#fff;
    }
    .articledetailpage .shareIcons .fa{
        color:#999   ;
        width:42px;
        height:42px;
        line-height:42px;
        margin:10px auto;
    }
    @media(min-width:768px){
        .articledetailpage > .container {
            padding: 0 75px;
        }
    }
    @media(max-width:767px){
        .shareIcons.bottom {
            text-align: center;
        }

        .articledetailpage > .container > .shareIcons {
            position: static;
            width: auto;
            height: auto;
            padding: 0 0 10px;
        }

        .articledetailpage > .container > .shareIcons:before {
            display: none;
        }

        .articledetailpage .shareIcons .fa {
            margin: 0 10px 10px;
        }

        .articledetailpage .pinklinksholder {
            border: 0 none transparent;
            border-top: 1px solid #f0617d;
            margin-top: 10px;
            border-radius: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// SetTone.vue?7de650c2